"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/menu/dist/mdc.menu.css");
require("@material/menu-surface/dist/mdc.menu-surface.css");
require("@rmwc/list/styles");
